import { useInfiniteQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export const NOTIFICATIONS_PAGE_SIZE = 30;
/**
 * Next offset for the paged notifications list: a full page means there may
 * be more (offset = items fetched so far); a short page means we're done.
 */
export function nextNotificationsOffset(lastPage, allPages) {
    if (lastPage.length < NOTIFICATIONS_PAGE_SIZE)
        return undefined;
    return allPages.reduce((total, page) => total + page.length, 0);
}
/**
 * Paged notifications list for one tab of the notifications page:
 * "Nuevas" (isRead=false) vs "Archivo" (isRead=true — read = handled).
 * The bell badge does NOT use this: it keeps its dedicated unread-count
 * query in NotificationsProvider.
 */
export function useNotificationsList(isRead, enabled = true) {
    return useInfiniteQuery({
        queryKey: ['notifications', 'list', isRead],
        queryFn: ({ pageParam }) => apiClient(`/notifications?is_read=${isRead}&limit=${NOTIFICATIONS_PAGE_SIZE}&offset=${pageParam}`),
        initialPageParam: 0,
        getNextPageParam: nextNotificationsOffset,
        enabled,
        // Only the inbox needs to surface fresh notifications while open; the
        // archive changes exclusively through the user's own mark-as-read actions.
        refetchInterval: isRead ? false : 60_000,
    });
}
//# sourceMappingURL=useNotificationsList.js.map